import React from 'react';
import { Flex, Box, useDisclosure } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import SideBar from 'Component/sideBar';
import Header from 'Component/header';
import { Condition } from 'Component/others';
import DashboardSkeleton from 'Component/dashboard-skeleton';
import DashboardWidget from 'Component/dashboard-widget';
import checkPublicRoute from 'Helper/checkPublicRoute';
import { useAppSystem } from 'Store/app';

import styles from './styles.module.css';

const DashboardContainer = ({ children }) => {
  const { isOpen: isShrinkNavbar, onClose: onExpand, onOpen: onShrinkNavbar } = useDisclosure();
  const { pathname } = useLocation();
  const isPublic = checkPublicRoute(pathname);
  const { isLoadingPage } = useAppSystem();

  return (
    <Flex className={styles['dashboard__container']}>
      <Condition statement={!isPublic} fallback={children}>
        <Box className={styles['section__container--left']}>
          <SideBar isShrink={isShrinkNavbar} onExpand={onExpand} onShrink={onShrinkNavbar} />
        </Box>

        <Box
          className={`${styles['section__container--right']} 
          ${isShrinkNavbar ? styles['section__container--right-shrink'] : ''}`}
        >
          <Header />
          <Condition statement={!isLoadingPage} children={children} fallback={<DashboardSkeleton />} />
        </Box>
      </Condition>

      {/* wigdet component */}
      <DashboardWidget />
    </Flex>
  );
};

export default DashboardContainer;
